import { useEffect } from 'react';

/**
 * Keep a route out of search results for as long as it is mounted.
 *
 * The admin sign-in URL is deliberately unadvertised — staff navigate to it
 * directly. Removing the links is only half of that: without this, a crawler
 * that reaches the URL some other way would put it back in public view.
 *
 * This is a single-page app, so the tag has to be added and removed per route
 * rather than living in `index.html`, which would deindex the marketing page too.
 */
export function useNoIndex(): void {
    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.appendChild(meta);

        return () => {
            document.head.removeChild(meta);
        };
    }, []);
}
